import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// 1. EXISTING ADMIN IMPORTS
// This "rootReducer" contains your existing Admin 'auth' and other slices
import rootReducer from "../features/index";
import { apiSlice as adminApiSlice } from "@/services/api/baseApi";

// 2. NEW CUSTOMER IMPORTS
import { apiSlice as customerApiSlice } from "@/servicescustomerside/api/baseApi";
import customerAuthReducer from "../slices/customerAuthSlice";

// 3. MERGE REDUCERS
// We spread (...rootReducer) to keep all your existing Admin logic working exactly as before.
// We add the Customer logic with unique names so they don't touch the Admin stuff.
const appReducers = {
  ...rootReducer,
  [adminApiSlice.reducerPath]: adminApiSlice.reducer, // Ensure Admin API is present

  // --- CUSTOMER SIDE ---
  customerAuth: customerAuthReducer, // Separate Customer Auth
  [customerApiSlice.reducerPath]: customerApiSlice.reducer, // Separate Customer API
};

// 4. PERSIST CONFIGURATION
const persistConfig = {
  key: "root",
  storage,
  // Persist 'auth' (from rootReducer/Admin) AND 'customerAuth' (new Customer)
  whitelist: ["auth", "customerAuth"],
  // Do not persist API caches to avoid staleness
  blacklist: [adminApiSlice.reducerPath, customerApiSlice.reducerPath],
};

const combinedReducer = combineReducers(appReducers);
const persistedReducer = persistReducer(persistConfig, combinedReducer);

// 5. CREATE STORE
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    })
      .concat(adminApiSlice.middleware) // Admin API Middleware
      .concat(customerApiSlice.middleware), // Customer API Middleware
});

export const persistor = persistStore(store);
